import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Coupon = ApplicationRecord.extend({
  static: {
    jsonapiType: 'coupons',
  },
  attrs: {
    active: attr(),
    availableGrades: attr(),
    availableSchools: attr(),
    code: attr(),
    couponType: attr(),
    endDate: attr(),
    value: attr(),
    flatValue: attr({ persist: false }),
    daysPostJob: attr({ persist: false }),
    daysPostJobStart: attr({ persist: false }),
    promoHeadline: attr({ persist: false }),
    promoSubhead: attr({ persist: false }),
    expiresOn: attr({ persist: false }),
    useInOrderFlow: attr({ persist: false }),
    imageUrl: attr(),
    // The add-ons a FREE_ADDON_CHOICE offer lets the parent pick from (#5747):
    // an array of plain objects with the SAME camel-case keys an Addon record
    // has (cssName, imageUrl, backgroundSelection, allowsJpgPoses, ...), so the
    // gifts renderer and poseEligibility read them unchanged. Empty otherwise.
    freeAddons: attr({ persist: false }),
    // What to call the free item, typed on the coupon screen (#5747); blank
    // means derive it from the set. See offerPricing.js freeItemLabel.
    freeItemLabel: attr({ persist: false }),
  },
});

export default Coupon;
